import * as actionTypes from '../../Action/actionTypes';

export const getAllCorporateUsers = (data) => {
  return {
    type: actionTypes.GET_ALL_CORPORATE_USERS,
    value: data
  }
};
